import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { HasAllGroupsPipe } from './has-all-groups.pipe';
import { HasAllPermsPipe } from './has-all-perms.pipe';
import { HasEitherGroupPipe } from './has-either-group.pipe';
import { HasEitherPermPipe } from './has-either-perm.pipe';
import { TimePastPipe } from './time-past.pipe';

@NgModule({
  declarations: [
    HasAllPermsPipe,
    HasEitherPermPipe,
    HasAllGroupsPipe,
    HasEitherGroupPipe,
    TimePastPipe,
  ],
  imports: [CommonModule],
  exports: [
    HasAllPermsPipe,
    HasEitherPermPipe,
    HasAllGroupsPipe,
    HasEitherGroupPipe,
    TimePastPipe,
  ],
  providers: [
    HasAllPermsPipe,
    HasEitherPermPipe,
    HasAllGroupsPipe,
    HasEitherGroupPipe,
    TimePastPipe,
  ],
})
export class PipesModule {}
